exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1bvyP{line-height:43px}span{text-decoration:none}span:active,span:focus,span:hover,span:visited{text-decoration:none!important}", ""]);

// exports
exports.locals = {
	"saveBtn": "_1bvyP"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/Header/List/SaveButton.css
// module id = 2537
// module chunks = 15